<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">{{ $t('serviceSubscription.pageTitle') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">{{
              $t('serviceSubscription.studentName')
            }}</label>
            <div class="overflow-auto ts-h-64">
              <table class="table table-hover ui-table ts-table">
                <thead>
                  <tr>
                    <th>{{ $t('serviceSubscription.cardNumber') }}</th>
                    <th>{{ $t('serviceSubscription.studentName') }}</th>
                  </tr>
                  <tr>
                    <th colspan="2">
                      <input
                        v-model.trim="searchValue"
                        type="text"
                        class="form-control"
                        :class="{ loading: student_search }"
                        :placeholder="$t('serviceSubscription.searchStudent')"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(student, index) in studentResource"
                    :key="index"
                    @dblclick="selectStudent(student)"
                  >
                    <td
                      :class="{
                        'selected-class': student.student_id == model.student_id
                      }"
                    >
                      {{ student.card_number }}
                    </td>
                    <td
                      :class="{
                        'selected-class': student.student_id == model.student_id
                      }"
                    >
                      {{ student.full_name_en }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="validate" v-if="errors.has('student_id')">
                {{ errors.first('student_id') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <ts-loading-banner :loading="loading">
            <div class="row form-group">
              <div class="col-md-12">
                <label class="required">{{
                  $t('serviceSubscription.feeType')
                }}</label>
                <treeselect
                  :load-options="loadFeeTypeOptions"
                  :options="feetypeOptions"
                  :limit="3"
                  :placeholder="$t('select')"
                  v-model="model.fee_type_id"
                  @select="() => (model.fee_setup_id = null)"
                ></treeselect>
                <div class="validate" v-if="errors.has('fee_type_id')">
                  {{ errors.first('fee_type_id') }}
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <label class="required">{{
                  $t('serviceSubscription.feeName')
                }}</label>
                <treeselect
                  :load-options="loadFeeSetup"
                  :options="feeSetupArrayList"
                  :placeholder="$t('select')"
                  :zIndex="99999"
                  v-model="model.fee_setup_id"
                ></treeselect>
                <div class="validate" v-if="errors.has('way_id')">
                  {{ errors.first('way_id') }}
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <label>{{ $t('serviceSubscription.comment') }}</label>
                <textarea
                  v-model.trim="model.description"
                  rows="3"
                  class="form-control"
                ></textarea>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <ts-checkbox v-model="model.subs_status">{{
                  $t('serviceSubscription.subscript')
                }}</ts-checkbox>
              </div>
            </div>
          </ts-loading-banner>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button @click="$emit('close')" class="mr-2">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            color="primary"
            outline
            class="mr-2"
            :waiting="waiting_new"
            @click.prevent="saveNew"
            >{{ $t('save_add_new') }}</ts-button
          >
          <ts-button color="primary" :waiting="waiting" @click.prevent="save">{{
            $t('save')
          }}</ts-button>
        </div>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'serviceSubscriptionForm',
  data() {
    return {
      model: {
        student_id: '',
        fee_type_id: null,
        subs_status: true,
        description: '',
        fee_setup_id: null
      },
      loading: false,
      errors: new Errors(),
      student_search: false,
      studentResource: [],
      searchValue: '',
      options: [],
      feetypeOptions: null,
      feeSetupList: null,
      waiting: false,
      waiting_new: false,
      feeSetupHasSubcribe: []
    }
  },
  created() {
    this.searchStudent({
      perPage: 15
    })
  },
  computed: {
    feeSetupArrayList() {
      if (this.feeSetupList != null) {
        if (this.feeSetupList.length > 0) {
          return this.feeSetupList
            .filter(
              f =>
                f.fee_type_id == this.model.fee_type_id &&
                !_.includes(this.feeSetupHasSubcribe, f.fee_setup_id)
            )
            .map(el => ({
              id: el.fee_setup_id,
              label: el.fee_name_en
            }))
        }
      }
      return null
    }
  },
  methods: {
    ...mapActions('serviceSubscription', [
      'getStudent',
      'getFeeType',
      'getFeeSetup',
      'store',
      'fetchStudentSubscript'
    ]),
    selectStudent(student) {
      this.clearInput()
      this.loading = true
      this.model.student_id = student.student_id
      this.fetchStudentSubscript({
        page: -1,
        filter: {
          student_id: this.model.student_id
        }
      })
        .then(response => {
          this.setFeeSetupHasSubscribe(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveNew() {
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    searchStudent(attributes) {
      this.student_search = true
      this.getStudent(attributes)
        .then(response => {
          this.studentResource = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.student_search = false
        })
    },
    async loadFeeTypeOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getFeeType({
          page: -1,
          fields: {
            setup_payment_fee_types: 'fee_type_id,fee_type_name'
          },
          filter: {
            fee_type_id: '2,3'
          }
        })
          .then(response => {
            this.feetypeOptions = response.data
              .filter(f => f.fee_type_id != 1)
              .map(el => ({
                id: el.fee_type_id,
                label: el.fee_type_name
              }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    async loadFeeSetup({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getFeeSetup({
          page: -1,
          fields: {
            setup_payment_fee_setups: 'fee_setup_id,fee_name_en,fee_type_id'
          },
          filter: {
            fee_type_id: '2,3'
          }
        })
          .then(response => {
            this.feeSetupList = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    clearInput() {
      this.model = {
        student_id: '',
        fee_type_id: null,
        subs_status: true,
        description: '',
        fee_setup_id: null
      }
    },
    setFeeSetupHasSubscribe(data) {
      if (data.length > 0) {
        this.feeSetupHasSubcribe = data.map(el => el.fee_setup_id)
      }
    }
  },
  watch: {
    searchValue: debounce(function(search) {
      this.searchStudent({
        page: -1,
        search: search
      })
    }, 500)
  }
}
</script>

<style lang="css" scoped>
table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}
.selected-class {
  border-bottom: 1px solid #69bafb;
  border-top: 1px solid #69bafb;
  background: #f2f3f4;
}

table > tbody > tr > td {
  cursor: pointer;
}
.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
</style>
